import Image from "next/image";

import { SABINE_DIRECT_AVATAR_SRC, SABINE_NAME } from "@/lib/sabine";
import { cn } from "@/lib/utils";

const SIZES = {
  // The Ask button above the page.
  sm: { box: "h-7 w-7", px: 28, dot: "h-2 w-2" },
  // The chat's header.
  md: { box: "h-9 w-9", px: 36, dot: "h-2.5 w-2.5" },
};

/** Sabine's face with her "online" dot, where she leads a row. */
export default function SabineLead({ size = "md" }) {
  const { box, px, dot } = SIZES[size] || SIZES.md;
  return (
    <span className={cn("relative flex shrink-0 self-center", box)}>
      <Image
        src={SABINE_DIRECT_AVATAR_SRC}
        alt={SABINE_NAME}
        width={px}
        height={px}
        className={cn(
          "rounded-full object-cover object-top ring-2 ring-white",
          box,
        )}
      />
      <span
        className={cn(
          "absolute bottom-0 right-0 rounded-full border-2 border-white bg-green-500",
          dot,
        )}
      />
    </span>
  );
}
